import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import EmployeeLayout from "../layouts/EmployeeLayout";

import EmpDashboard from "../pages/Employee/EmpDashboard";
import EmpProfile from "../pages/Employee/EmpProfile";
import EmpLeaves from "../pages/Employee/EmpLeaves";
import EmpApplyLeave from "../pages/Employee/EmpApplyLeave";
import EmpAttendance from "../pages/Employee/EmpAttendance";
import EmpPayslips from "../pages/Employee/EmpPayslips";
import EmpHolidays from "../pages/Employee/EmpHolidays";
import EmpTimesheets from "../pages/Employee/EmpTimesheets";

export default function EmployeeRoutes() {
  return (
    <Routes>
      <Route path="/" element={<EmployeeLayout />}>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path="dashboard" element={<EmpDashboard />} />
        <Route path="profile" element={<EmpProfile />} />
        <Route path="leaves" element={<EmpLeaves />} />
        <Route path="apply-leave" element={<EmpApplyLeave />} />
        <Route path="attendance" element={<EmpAttendance />} />
        <Route path="payslips" element={<EmpPayslips />} />
        <Route path="holidays" element={<EmpHolidays />} />
        <Route path="timesheets" element={<EmpTimesheets />} />
      </Route>
    </Routes>
  );
}
